import { Field as FieldPrimitive } from "@base-ui/react";
import { cn } from "@maker/utils/cn";
import { Input, type InputProps } from "./input";
import { Label } from "./label";

const Field = ({ className, ...props }: FieldPrimitive.Root.Props) => {
	return (
		<FieldPrimitive.Root className={cn("space-y-1.5", className)} {...props} />
	);
};

const FieldLabel = (props: FieldPrimitive.Label.Props) => {
	return <FieldPrimitive.Label render={<Label />} {...props} />;
};

const FieldInput = (props: FieldPrimitive.Control.Props & InputProps) => {
	return <FieldPrimitive.Control render={<Input {...props} />} />;
};

export { Field, FieldLabel, FieldInput };
